import { gql } from "@apollo/client"

const GET_EVENT_SYNC_REPORT = gql`
  query($eventId: ID!) {
    eventSyncReport(event_id: $eventId) {
      filename
      url
      type
      queued
    }
  }
`

export { GET_EVENT_SYNC_REPORT }